import { IoLockClosed } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { Button, Card, Col, Row } from "reactstrap";
import { AuthHalfScreenComp } from "../../components/commonComponents";
import CheckedInput from "../../components/inputs/CheckedInput";
import IconInput from "../../components/inputs/IconInput";
import useAuthHooks from "../../hooks/useAuthHooks";
import { useTranslation } from "../../languages";
const Login = ({ onAuthSuccess }) => {
  const {
    //all local states
    credentials,
    setCredentials,
    //all functions
    onPressLoginBtn,
    loading,
  } = useAuthHooks(onAuthSuccess);
  const { t } = useTranslation();
  return (
    <Row className="full-screen m-0">
      <AuthHalfScreenComp />
      <Col
        md={6}
        lg={5}
        className="d-flex py-3 align-items-center justify-content-center"
      >
        <Card className="bg-transparent border-none full-width mx-xl-5 mx-4">

          <h4 className="f-7">{t("welcomeTo")} Activity-Maps</h4>
          <div className="mt-4 mb-3">
            <IconInput
              Icon={MdOutlineEmail}
              className={"mb-3"}
              placeholder={"Email Address"}
              setValue={(v) =>
                setCredentials((prev) => ({ ...prev, email: v }))
              }
              type={"email"}
              value={credentials?.email}
            />
            <IconInput
              Icon={IoLockClosed}
              placeholder={"Password"}
              className={"mb-4"}
              setValue={(v) =>
                setCredentials((prev) => ({ ...prev, password: v }))
              }
              type={"password"}
              value={credentials?.password}
            />
            <div className="d-flex justify-content-between  px-2 mb-3">
              <span className="d-flex gap-2 align-items-center">
                <CheckedInput
                  iconSize={24}
                  value={credentials?.rememberMe}
                  setValue={(v) =>
                    setCredentials((prev) => ({ ...prev, rememberMe: v }))
                  }
                />
                <p className="color-primary-blue m-0 f-5">{t("rememberMe")}</p>
              </span>
              <Link
                to={"/forgot-password"}
                className="color-primary-blue m-0 f-5 text-decoration-none"
              >
                {t("forgottenPassword")}
              </Link>
            </div>
          </div>
          <Button
            onClick={onPressLoginBtn}
            className="standard-rounded-btn py-3 mb-4 full-width"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {t("loggingIn")}...
              </>
            ) : (
              t("login")
            )}
          </Button>
          <div className="d-flex gap-2 mb-5 justify-content-center align-items-center flex-wrap">
            <span className="color-half-black">{t("dontHaveAccount")}</span>
            <Link to={"/signup"} className="text-black text-decoration-none">
              {t("signUp")}
            </Link>
          </div>
          <div className="d-flex justify-content-center full-width gap-1">
            <CheckedInput
              value={credentials?.agree}
              setValue={(v) =>
                setCredentials((prev) => ({ ...prev, agree: v }))
              }
              iconSize={25}
            />
            <p className="color-half-black-2 m-0">
              {t("byTappingConfirm")}{" "}
              <a target="_blank" href="https://activity-maps.com/terms-conditions" className="text-decoration-none text-primary">
                {t("termsOfService")}
              </a>{" "}
              <a target="_blank" href="https://activity-maps.com/privacy-policy" className="text-decoration-none text-primary">
                {t("andPrivacyPolicy")}
              </a>
            </p>
          </div>
        </Card>
      </Col>
    </Row>
  );
};
export default Login;
